import * as React from 'react';
import Modal from 'components/src/modal';
import { PackageCardFieldsFragment } from '../../../@types/generated';
import { getOr } from '@/utils/options';
import Tab, { Tabs, TabPanel } from 'components/src/tab';
import InfoSetSection from '../InfoSetSection';

type Props = {
  isOpen: boolean;
  modalData: PackageCardFieldsFragment['iconContainerModal'];
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const CardModal = ({ isOpen, modalData, setModalOpen }: Props) => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const handleChangeTab = (newTabIndex: number) => {
    setSelectedIndex(newTabIndex);
  };

  return (
    <Modal
      isOpen={isOpen}
      heading={getOr(modalData?.title, '')}
      subheading={getOr(modalData?.description, '')}
      onClose={() => setModalOpen(false)}
    >
      <Tabs>
        {modalData?.tabsCollection?.items?.map((tab, index) => {
          return (
            <Tab
              key={`${tab?.title}-${index}`}
              index={index}
              label={getOr(tab?.title, '')}
              selected={selectedIndex === index}
              onClick={handleChangeTab}
            />
          );
        })}
      </Tabs>
      {modalData?.tabsCollection?.items?.map((tab, index) => {
        return (
          <TabPanel key={`${tab?.title}-${index}`} value={selectedIndex} index={index}>
            {tab?.content?.__typename === 'InfoSet' && <InfoSetSection infoSetId={tab?.content?.sys?.id} />}
          </TabPanel>
        );
      })}
    </Modal>
  );
};
export default CardModal;
